import { FC, ReactNode, useEffect } from 'react';
import { ReCaptcha } from '../../core/recaptcha';

type Props = { children: ReactNode }

const DEFAULT_BODY_TAGS = ['NOSCRIPT', 'MAIN'];

const WithRecaptcha: FC<Props> = ({ children }) => {
  useEffect(() => {
    const body = document.querySelector('body');
    const scriptEl = document.createElement('script');
    scriptEl.innerHTML = ReCaptcha.SCRIPT_TEXT;
    scriptEl.async = true;
    body && body.appendChild(scriptEl);
    return () => {
      body && Array.from(body.children).forEach(el => {
        if (!DEFAULT_BODY_TAGS.includes(el.tagName)) {
          el.remove();
        }
      });
    };
  }, []);

  return (
    <>
      {children}
    </>
  );
};

export default WithRecaptcha;